import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UserLogEventType } from '@shared/constants/user-log-event-type';
import { UserLogEventService } from '@shared/services/user-log-event.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-post-login',
  templateUrl: './post-login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PostLoginComponent implements OnInit {
  private userLogEventService = inject(UserLogEventService);
  private oidc = inject(OidcSecurityService);

  ngOnInit(): void {
    this.oidc
      .isAuthenticated()
      .pipe(
        filter(isAuthenticated => !!isAuthenticated),
        take(1)
      )
      .subscribe(() => {
        this.userLogEventService.logEvent(UserLogEventType.UserLogin);
      });
  }
}
